import { useState, useEffect } from 'react';

import BaseMarkdown from '@components/base/BaseMarkdown';
import useI18n, { LocaleTypes } from '@i18n';

import rulesEpnRU from './epn/content_ru.md';
import rulesEpnEN from './epn/content_en.md';
import rulesEpncpaEN from './epncpa/content_en.md';

const RULES_MAP = {
    epn: {
        [LocaleTypes.ru]: rulesEpnRU,
        [LocaleTypes.en]: rulesEpnEN,
    },
    epncpa: {
        [LocaleTypes.ru]: rulesEpncpaEN,
        [LocaleTypes.en]: rulesEpncpaEN,
    },
};

const RulesMarkdown: React.FC = () => {
    const { locale } = useI18n();
    const [markdown, setMarkdown] = useState<string>('');

    useEffect(() => {
        if (locale === LocaleTypes.ru) {
            setMarkdown(RULES_MAP[process.env.NEXT_PUBLIC_PROJECT_NAME].ru);
        } else {
            setMarkdown(RULES_MAP[process.env.NEXT_PUBLIC_PROJECT_NAME].en);
        }
    }, [locale]);

    return <BaseMarkdown markdown={markdown} className="mb-[100px]" />;
};

export default RulesMarkdown;
